import styled, { css } from 'styled-components'

export const Root = styled.div(
  () => css`
    display: flex;
    flex-direction: column;
  `,
)

export const Header = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.space['8']};
    margin-bottom: ${theme.space['4']};
  `,
)

export const Title = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['4']};
  `,
)

export const List = styled.div(
  ({ theme }) => css`
    border: ${theme.border.size['1']} solid ${theme.colors.gray500};
    border-radius: ${theme.border.radius['4']};
    overflow-y: auto;
    max-height: 40rem;
    margin-top: ${theme.space['16']};
  `,
)

export const Row = styled.div(
  ({ theme }) => css`
    display: flex;
    min-height: 5.6rem;
    align-items: center;
    gap: ${theme.space['16']};
    padding: ${theme.space['6']} ${theme.space['16']};
    border-bottom: ${theme.border.size['1']} solid ${theme.colors.gray400};
    background-color: ${theme.colors.white};

    &:last-child {
      border-bottom: none;
    }
  `,
)

export const DragHandle = styled.div<{ $disabled?: boolean }>(
  ({ theme, $disabled }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: ${theme.colors.black300};
    cursor: ${$disabled ? 'default' : 'grab'};
    width: 2rem;
  `,
)

export const ItemName = styled.span(
  ({ theme }) => css`
    flex: 1;
    min-width: 0;
    font-size: 1.4rem;
    color: ${theme.colors.black800};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
)

export const InputWrapper = styled.div`
  flex: 1;
  min-width: 0;
`

export const Actions = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['4']};
    flex-shrink: 0;
  `,
)
